import { useEffect, useState } from "react";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { api, formatErr } from "@/lib/api";

const Person = ({ p }) => <span><b>{p.name}</b> <span className="text-slate-400">({p.alias})</span></span>;

const Row = ({ g, onRevoke }) => {
  const hot = g.flags.length > 0 && !g.revoked;
  return (
    <li className={`rounded-2xl border p-3 space-y-1.5 ${hot ? "bg-rose-50 border-rose-300" : "bg-white border-pink-100"} ${g.revoked ? "opacity-60" : ""}`} data-testid={`secret-gift-row-${g.id}`} data-flagged={hot || undefined}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <p className="text-sm"><Person p={g.from} /> → <Person p={g.to} /></p>
        <span className={`font-extrabold ${hot ? "text-rose-600" : "text-pink-600"}`} data-testid={`secret-gift-amount-${g.id}`}>{g.amount.toLocaleString("de-DE")} Punkte</span>
      </div>
      <p className="text-xs text-slate-400">{new Date(g.created_at).toLocaleString("de-DE")}{g.thanked && " · Danke 💖"}{g.revoked && " · zurückgenommen"}</p>
      {hot && g.flags.map((f) => <p key={f} className="text-xs font-bold text-rose-600 flex items-center gap-1"><AlertTriangle className="w-3.5 h-3.5" /> {f}</p>)}
      {!g.revoked && <button onClick={() => onRevoke(g)} data-testid={`secret-gift-revoke-${g.id}`} className="h-8 px-3 rounded-full bg-slate-900 text-white text-xs font-bold">Geschenk zurücknehmen</button>}
    </li>
  );
};

export function SecretGiftsAdmin() {
  const [d, setD] = useState(null);
  const [onlyHot, setOnlyHot] = useState(false);
  const load = () => api.get("/secretchat/admin/gifts").then(({ data }) => setD(data)).catch(() => setD({ gifts: [], total: 0, flagged: 0 }));
  useEffect(() => { load(); }, []);
  const revoke = async (g) => {
    if (!window.confirm(`${g.amount} Punkte von ${g.to.name} zurücknehmen und ${g.from.name} zurückgeben?`)) return;
    try { await api.post(`/secretchat/admin/gifts/${g.id}/revoke`); toast.success("Geschenk zurückgenommen"); load(); } catch (e) { toast.error(formatErr(e)); }
  };
  if (!d) return null;
  const list = onlyHot ? d.gifts.filter((g) => g.flags.length && !g.revoked) : d.gifts;
  return (
    <div className="space-y-4 max-w-3xl" data-testid="secret-gifts-admin">
      <div className="flex flex-wrap items-center gap-2 text-sm">
        <span className="px-3 h-9 inline-flex items-center rounded-full bg-pink-50 font-bold" data-testid="secret-gifts-total">{d.total.toLocaleString("de-DE")} Punkte verschenkt</span>
        <span className="px-3 h-9 inline-flex items-center rounded-full bg-rose-100 text-rose-700 font-bold" data-testid="secret-gifts-flagged">{d.flagged} auffällig</span>
        <button onClick={() => setOnlyHot((v) => !v)} data-testid="secret-gifts-filter" className={`px-3 h-9 rounded-full font-bold ${onlyHot ? "bg-rose-500 text-white" : "bg-slate-100"}`}>Nur auffällige</button>
      </div>
      <p className="text-xs text-slate-500">Rot markiert: Geschenke ab 500 Punkten oder ab 1.000 Punkten in 7 Tagen zwischen denselben zwei Mitgliedern.</p>
      {list.length === 0 ? <p className="text-sm text-slate-400" data-testid="secret-gifts-empty">Keine Geschenke.</p>
        : <ul className="space-y-2">{list.map((g) => <Row key={g.id} g={g} onRevoke={revoke} />)}</ul>}
    </div>
  );
}
